import React from "react";
import { useUser } from "../../pages/login/UserContextPersistent";
import PoweredBy_Logo from "../../images/poweredBy.svg";
import Route_eye from "../../images/logo_route.svg";
// Import MUI Icons
import YouTubeIcon from "@mui/icons-material/YouTube";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useTranslation } from "react-i18next";

export default function Footer({ isLogin }) {
  const { state } = useUser();
  const { t } = useTranslation();
  const hasPermission = (requiredPath) => {
    if (!state?.features || !requiredPath) return true;
    return state.features.some((feature) =>
      feature.api_path.includes(requiredPath),
    );
  };

  const navigationItems = [
    { label: "Dashboard", path: "/dashboard", requiredFeature: "" },
    { label: "Vehicles", path: "/Vehicle", requiredFeature: "/api/vehicle" },
    { label: "Routes", path: "/route", requiredFeature: "/api/route" },
    { label: "Stops", path: "/stop", requiredFeature: "/api/stop" },
    { label: "Alerts", path: "/alert", requiredFeature: "/api/alert" },
    { label: "Schedules", path: "/schedule", requiredFeature: "/api/schedule" },
    { label: "Drivers", path: "/driver", requiredFeature: "/api/driver" },
    { label: "Sites", path: "/site", requiredFeature: "/api/site" },
    { label: "Users", path: "/user", requiredFeature: "/api/user" },
    { label: "Reports", path: "/reports", requiredFeature: "/api/managedata" },
    { label: "Settings", path: "/settings", requiredFeature: "" },
  ];

  // Add special organization items
  const orgData = JSON.parse(localStorage.getItem("userState") || "{}");
  const { organizationId: orgId, email: orgEmail } = orgData?.user || {};

  if (orgId === 5 && orgEmail === "sales@routeeye.io") {
    navigationItems.push(
      { label: "Organization", path: "/org", requiredFeature: "" },
      { label: "Features", path: "/feature", requiredFeature: "" },
      { label: "Devices", path: "/device", requiredFeature: "" },
    );
  }

  const filteredItems = navigationItems.filter((item) =>
    hasPermission(item.requiredFeature),
  );

  // Split into 4 columns
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const navigationChunks = chunkArray(filteredItems, 4);

  // Social Media Links Configuration
  // const socialLinks = [
  //     {
  //         name: 'YouTube',
  //         url: 'https://www.youtube.com/@RouteEye',
  //         icon: YouTubeIcon,
  //         hoverColor: '#FF0000'
  //     },
  //     {
  //         name: 'Facebook',
  //         url: 'https://www.facebook.com/people/RouteEye/61562437113837/',
  //         icon: FacebookIcon,
  //         hoverColor: '#1877F2'
  //     },
  //     {
  //         name: 'Twitter',
  //         url: 'https://twitter.com/routeeye',
  //         icon: TwitterIcon,
  //         hoverColor: '#1DA1F2'
  //     },
  //     {
  //         name: 'LinkedIn',
  //         url: 'https://linkedin.com/company/routeeye',
  //         icon: LinkedInIcon,
  //         hoverColor: '#0A66C2'
  //     },
  //     {
  //         name: 'Instagram',
  //         url: 'https://instagram.com/routeeye',
  //         icon: InstagramIcon,
  //         hoverColor: '#E4405F'
  //     }
  // ];

  if (isLogin) {
    return (
      <footer
        style={{
          backgroundColor: "#f9fafb",
          color: "#374151",
          padding: "24px",
          borderTop: "1px solid #e5e7eb",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div
            style={{
              display: "flex",
              gap: "40px",
              marginBottom: "10px",
            }}
          >
            {/* Company info - 50% */}
            <div style={{ flex: "1" }}>
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  alignItems: "center",
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    backgroundColor: "#3b82f6",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={Route_eye}
                    alt=""
                    style={{ width: "32px", height: "32px" }}
                  />
                </div>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: 700,
                    color: "#111827",
                  }}
                >
                  {t("RouteEye")}
                </span>
              </div>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "1.6",
                  color: "#6b7280",
                  margin: 0,
                }}
              >
                {t(
                  "Streamline your real-time vehicle tracking with our leading SaaS platform RouteEye. Trusted by over 100+ happy customers.",
                )}
              </p>
            </div>

            {/* Other sections container - 50% */}
            <div
              style={{
                flex: "1",
                display: "flex",
                gap: "32px",
              }}
            >
              {/* Resources */}
              <div style={{ flex: "1" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#111827",
                    margin: "0 0 16px 0",
                  }}
                >
                  {t("Resources")}
                </h3>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <li style={{ marginBottom: "12px" }}>
                    <a
                      href="https://routeeye.io/features/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        transition: "color 0.2s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                      onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                    >
                      {t("Features")}
                    </a>
                  </li>
                  {/* <li style={{ marginBottom: '12px' }}>
                                        <a
                                            href="https://routeeye.io/pricing/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#6b7280',
                                                textDecoration: 'none',
                                                fontSize: '14px',
                                                lineHeight: '1.5',
                                                transition: 'color 0.2s'
                                            }}
                                            onMouseEnter={(e) => e.target.style.color = '#1f2937'}
                                            onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                                        >
                                            Pricing
                                        </a>
                                    </li> */}
                  <li style={{ marginBottom: "12px" }}>
                    <a
                      href="https://routeeye.io/resources/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        transition: "color 0.2s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                      onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                    >
                      {t("Blogs")}
                    </a>
                  </li>
                </ul>
              </div>

              {/* Support */}
              <div style={{ flex: "1" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#111827",
                    margin: "0 0 16px 0",
                  }}
                >
                  {t("Support")}
                </h3>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <li style={{ marginBottom: "12px" }}>
                    <a
                      href="https://routeeye.io/support/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        transition: "color 0.2s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                      onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                    >
                      {t("Help")}
                    </a>
                  </li>
                  <li style={{ marginBottom: "12px" }}>
                    <a
                      href="https://routeeye.io/contact/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        transition: "color 0.2s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                      onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                    >
                      {t("Contact")}
                    </a>
                  </li>
                </ul>
              </div>

              {/* Terms */}
              <div style={{ flex: "1" }}>
                <h3
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                    color: "#111827",
                    margin: "0 0 16px 0",
                  }}
                >
                  {t("Terms")}
                </h3>
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                  }}
                >
                  <li style={{ marginBottom: "12px" }}>
                    <a
                      href="https://routeeye.io/terms/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        transition: "color 0.2s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                      onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                    >
                      {t("Terms")}
                    </a>
                  </li>
                  <li style={{ marginBottom: "12px" }}>
                    <a
                      href="https://routeeye.io/privacy/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        transition: "color 0.2s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                      onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                    >
                      {t("Privacy")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom section with MUI Icons */}
          <div
            style={{
              borderTop: "1px solid #d1d5db",
              paddingTop: "24px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >
            <div style={{ fontSize: "14px", color: "#6b7280" }}>
              © {t("Copyright 2025 • RouteEye • All rights reserved.")}
            </div>

            {/* Social Media Links with MUI Icons */}
            {/* <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px'
                        }}>
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                alignItems: 'center'
                            }}>
                                {socialLinks.map((social) => {
                                    const IconComponent = social.icon;
                                    return (
                                        <a
                                            key={social.name}
                                            href={social.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: '#6b7280',
                                                transition: 'color 0.2s',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}
                                            onMouseEnter={(e) => e.target.style.color = social.hoverColor}
                                            onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                                            title={social.name}
                                        >
                                            <IconComponent sx={{ fontSize: 20 }} />
                                        </a>
                                    );
                                })}
                            </div>
                        </div> */}

            <div style={{ fontSize: "14px", color: "#6b7280" }}>
              {t("Powered by")}{" "}
              <img
                src={PoweredBy_Logo}
                alt="powered by logo"
                style={{ height: "16px" }}
              />
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer
      style={{
        backgroundColor: "#f9fafb",
        color: "#374151",
        padding: "24px",
        marginTop: "20px",
        borderTop: "1px solid #e5e7eb",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 2fr))",
            gap: "40px",
            marginBottom: "40px",
          }}
        >
          {/* Company info - 50% */}
          <div style={{ flex: "1" }}>
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                marginBottom: "16px",
              }}
            >
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#3b82f6",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={Route_eye}
                  alt=""
                  style={{ width: "32px", height: "32px" }}
                />
              </div>
              <span
                style={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "#111827",
                }}
              >
                {t("RouteEye")}
              </span>
            </div>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
                color: "#6b7280",
                margin: 0,
              }}
            >
              {t(
                "Streamline your real-time vehicle tracking with our leading SaaS platform RouteEye. Trusted by over 100+ happy customers.",
              )}
            </p>
          </div>

          {/* Other sections container - 50% */}
          <div
            style={{
              flex: "1",
              display: "flex",
              gap: "32px",
            }}
          >
            {/* Resources */}
            <div style={{ flex: "1" }}>
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#111827",
                  margin: "0 0 16px 0",
                }}
              >
                {t("Resources")}
              </h3>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="https://routeeye.io/features/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#6b7280",
                      textDecoration: "none",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                    onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                  >
                    {t("Features")}
                  </a>
                </li>
                {/* <li style={{ marginBottom: '12px' }}>
                                    <a
                                        href="https://routeeye.io/pricing/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: '#6b7280',
                                            textDecoration: 'none',
                                            fontSize: '14px',
                                            lineHeight: '1.5',
                                            transition: 'color 0.2s'
                                        }}
                                        onMouseEnter={(e) => e.target.style.color = '#1f2937'}
                                        onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                                    >
                                        Pricing
                                    </a>
                                </li> */}
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="https://routeeye.io/resources/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#6b7280",
                      textDecoration: "none",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                    onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                  >
                    {t("Blogs")}
                  </a>
                </li>
              </ul>
            </div>

            {/* Support */}
            <div style={{ flex: "1" }}>
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#111827",
                  margin: "0 0 16px 0",
                }}
              >
                {t("Support")}
              </h3>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="https://routeeye.io/support/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#6b7280",
                      textDecoration: "none",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                    onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                  >
                    {t("Help")}
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="https://routeeye.io/contact/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#6b7280",
                      textDecoration: "none",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                    onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                  >
                    {t("Contact")}
                  </a>
                </li>
              </ul>
            </div>

            {/* Terms */}
            <div style={{ flex: "1" }}>
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#111827",
                  margin: "0 0 16px 0",
                }}
              >
                {t("Terms")}
              </h3>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                }}
              >
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="https://routeeye.io/terms/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#6b7280",
                      textDecoration: "none",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                    onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                  >
                    {t("Terms")}
                  </a>
                </li>
                <li style={{ marginBottom: "12px" }}>
                  <a
                    href="https://routeeye.io/privacy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#6b7280",
                      textDecoration: "none",
                      fontSize: "14px",
                      lineHeight: "1.5",
                      transition: "color 0.2s",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                    onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                  >
                    {t("Privacy")}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Navigation links - 4 columns */}
          {filteredItems.length > 0 && (
            <div
              style={{
                borderLeft: "1px solid #737c89ff",
                paddingLeft: "36px",
              }}
            >
              <h3
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#111827",
                  margin: "0 0 16px 0",
                }}
              >
                {t("My Account")}
              </h3>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: "12px",
                }}
              >
                {navigationChunks.map((chunk, chunkIndex) =>
                  chunk.map((item, itemIndex) => (
                    <a
                      key={`${chunkIndex}-${itemIndex}`}
                      href={item.path}
                      style={{
                        color: "#6b7280",
                        textDecoration: "none",
                        fontSize: "14px",
                        lineHeight: "1.5",
                        transition: "color 0.2s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1f2937")}
                      onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                    >
                      {t(item.label)}
                    </a>
                  )),
                )}
              </div>
            </div>
          )}
        </div>

        {/* Bottom section with MUI Icons */}
        <div
          style={{
            borderTop: "1px solid #d1d5db",
            paddingTop: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "16px",
          }}
        >
          <div style={{ fontSize: "14px", color: "#6b7280" }}>
            © {t("Copyright 2025 • RouteEye • All rights reserved.")}
          </div>

          {/* Social Media Links with MUI Icons */}
          {/* <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px'
                    }}>
                        <div style={{
                            display: 'flex',
                            gap: '12px',
                            alignItems: 'center'
                        }}>
                            {socialLinks.map((social) => {
                                const IconComponent = social.icon;
                                return (
                                    <a
                                        key={social.name}
                                        href={social.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: '#6b7280',
                                            transition: 'color 0.2s',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                        onMouseEnter={(e) => e.target.style.color = social.hoverColor}
                                        onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                                        title={social.name}
                                    >
                                        <IconComponent sx={{ fontSize: 20 }} />
                                    </a>
                                );
                            })}
                        </div>
                    </div> */}

          <div style={{ fontSize: "14px", color: "#6b7280" }}>
            {t("Powered by")}{" "}
            <img
              src={PoweredBy_Logo}
              alt="powered by logo"
              style={{ height: "16px" }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
